module.exports = __webpack_public_path__ + "img/noodles-1.a86a5826.jpg";